export default "__VITE_ASSET__mYCUaHxg__"